import { Moment } from "moment";
import { Booking, BookingCategory } from "PFTypes";
import { createContext, useContext } from "react";

import { BookingWithProfileId } from "./use_profile_bookings";

export type CalendarSearch = {
  isSearchEnabled: boolean;
  search: string;
  setSearch: (search: string) => void;
};

type ProfileBookingsConfig = { tooltip?: { hideActivityLink?: boolean } };
type ProfileBookingsContextType = {
  selectedBooking: Booking | null;
  bookings: BookingWithProfileId[];
  bookingCategories: BookingCategory[];
  config?: ProfileBookingsConfig;
  jobCodeDisplayAs: string;
  refreshBookings: () => void;
  selectBooking: (booking: Booking) => void;
  handleDateRangeChange: (min: Moment, max: Moment, currentMonth: Moment) => void;
  fetchAllBookings: () => void;
  calendarSearch: CalendarSearch;
};

export const ProfileBookingsContext = createContext({} as ProfileBookingsContextType);

export const useProfileBookingsContext = () => useContext(ProfileBookingsContext);
